/** Progress, never a grade: a thin bar in the brand colour (no red, no green on a person or a folder). */
export function ProgressBar({
  total,
  inLine,
  label,
}: {
  readonly total: number;
  readonly inLine: number;
  readonly label: string;
}) {
  const share = total > 0 ? Math.round((inLine / total) * 100) : 100;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={inLine}
      className="bg-muted h-1.5 w-full overflow-hidden rounded-full"
    >
      <div className="h-full rounded-full bg-[var(--progress)]" style={{ width: `${share}%` }} />
    </div>
  );
}
